import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { NgOptimizedImage } from '@angular/common';
import { MOCK_PRODUCT_TOKEN, MockProduct } from '@libs/configs/calculate.token';
import { PipesModule } from '@libs/modules/pipes.module';

@Component({
  selector: 'app-service-info',
  templateUrl: './service-info.component.html',
  styleUrls: ['./service-info.component.sass'],
  standalone: true,
  imports: [TranslateModule, NgOptimizedImage, PipesModule],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceInfoComponent {
  public mockProduct: MockProduct = inject(MOCK_PRODUCT_TOKEN);
}
